<template>
    <main class="news all_posts">

        <article class="news news2">
            <ArticleLogo />
        </article>
        <!-- <div v-if="$route.path.includes('/team')" class="sub_container_b">
            <NewsSubMenu name="fixtures" route="fixtures" />
            <NewsSubMenu name="results" route="results" />
            <NewsSubMenu name="Squad" route="squad" />

        </div> -->
        <ul class="squad">
            <SquadPlayers :players="players" />
        </ul>

    </main>
</template>

<script>
// import NewsSubMenu from '@/components/team/NewsSubMenu.vue';
import SquadPlayers from '@/components/team/SquadPlayers.vue'
import ArticleLogo from '@/components/ArticleLogo.vue'
export default {
    name: 'SquadVue',
    components: { ArticleLogo, SquadPlayers },
    inject: ['backendServer', 'currentHost'],

    data() {
        return {
            players: null,
        }
    },
    mounted() {
        fetch(this.backendServer() + '/squad', {
            method: "GET",
            credentials: "include"
        })
            .then((response) => response.json())
            .then((data) => {
                this.players = data;
            });

    }
}
</script>

<style>
ul.squad {
    display: flex;
    margin-top: 50px;
    justify-content: center;
}
</style>